import { render, staticRenderFns } from "./DocumentGroupDefine.vue?vue&type=template&id=01cbfa57&scoped=true&"
import script from "./DocumentGroupDefine.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupDefine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cbfa57",
  null
  
)

export default component.exports